module.exports = __webpack_public_path__ + "static/media/biendli-icon.c862db04.svg";